import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';
import { HOOK_FIELD__has_effect_on_generation } from '../../_hooks/HOOK_FIELD__has_effect_on_generation';

interface PROPS {
  field: FIELD__base;
  is_visible: boolean;
  class_name_wrapper?: string;
}

export function G_UI_FIELD__overlay_not_used({ field, is_visible, class_name_wrapper = 'rounded-lg' }: PROPS) {
  let is_used = HOOK_FIELD__has_effect_on_generation(field);

  function get_opacity() {
    if (field.meta.grid2d__is_dimension) return 'opacity-0';
    if (is_used) return 'opacity-0';
    if (!is_visible) return 'opacity-0';

    return 'opacity-100';
  }

  let class_name_base = `absolute inset-0 size-full z-0
  transition-opacity duration-300 ${get_opacity()} pointer-events-none`;

  return (
    <>
      <div className={` bg-black/50 border-y border-component-border ${class_name_wrapper}  ${class_name_base}`} />
      <div className={`${class_name_base} flex flex-center`}>
        <span className={`border border-component-border px-2 py-1  text-xs rounded-md bg-black font-bold text-component-item-foreground `}>Not used</span>
      </div>
    </>
  );
}
